export function readCspNonce(): string {
  if (typeof document === "undefined") {
    return "";
  }

  const meta =
    document.querySelector<HTMLMetaElement>('meta[name="csp-nonce"]') ??
    document.querySelector<HTMLMetaElement>('meta[property="csp-nonce"]');

  return meta?.content ?? "";
}
